'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash.debounce');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * React FitText
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * https://github.com/kennethormandy/react-fittext
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Kenneth Ormandy
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * A rewrite of https://github.com/gianu/react-fittext (MIT)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * …which is based on the FitText jQuery plugin
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * http://github.com/davatron5000/FitText.js
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var FitText = function (_React$Component) {
  _inherits(FitText, _React$Component);

  function FitText(props) {
    _classCallCheck(this, FitText);

    var _this = _possibleConstructorReturn(this, (FitText.__proto__ || Object.getPrototypeOf(FitText)).call(this, props));

    var defaultFontSize = props.defaultFontSize;

    if (typeof props.defaultFontSize === 'number') {
      defaultFontSize = props.defaultFontSize + 'px';
    }

    _this.state = {
      fontSize: defaultFontSize
    };

    _this._onBodyResize = _this._onBodyResize.bind(_this);
    _this._parentNode = null;
    return _this;
  }

  _createClass(FitText, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // When a new parent ID is passed in, or the new parentNode
      // is available, run resize again
      if (this.props.parent !== prevProps.parent) {
        this._onBodyResize();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (0 >= this.props.compressor) {
        console.warn('Warning: The compressor should be greater than 0.');
      }

      if (this.props.parent) {
        this._parentNode = typeof this.props.parent === 'string' ? document.getElementById(this.props.parent) : this.props.parent;
      }

      window.addEventListener('resize', (0, _lodash2.default)(this._onBodyResize, this.props.debounce));
      this._onBodyResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', (0, _lodash2.default)(this._onBodyResize, this.props.debounce));
    }
  }, {
    key: '_getFontSize',
    value: function _getFontSize(value) {
      var props = this.props;

      return Math.max(Math.min(value / (props.compressor * 10), props.maxFontSize), props.minFontSize);
    }
  }, {
    key: '_onBodyResize',
    value: function _onBodyResize() {
      if (this.element && this.element.offsetWidth) {
        var value = this.element.offsetWidth;

        if (this.props.vertical) {
          var parent = this._parentNode || this.element.parentNode;
          value = parent.offsetHeight;
        }

        var newFontSize = this._getFontSize(value);

        this.setState({
          fontSize: newFontSize + 'px'
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(el) {
            return _this2.element = el;
          },
          style: { fontSize: this.state.fontSize } },
        this.props.children
      );
    }
  }]);

  return FitText;
}(_react2.default.Component);

FitText.defaultProps = {
  compressor: 1.0,
  debounce: 100,
  defaultFontSize: 'inherit',
  minFontSize: Number.NEGATIVE_INFINITY,
  maxFontSize: Number.POSITIVE_INFINITY
};

FitText.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string]),
  compressor: _propTypes2.default.number,
  debounce: _propTypes2.default.number,
  defaultFontSize: _propTypes2.default.string,
  minFontSize: _propTypes2.default.number,
  maxFontSize: _propTypes2.default.number,
  parent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
};

exports.default = FitText;